// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_3mLte","hidden":"_302yX","title":"_1TPj9","link":"_2qhGi"};